import { render } from "./FeatureComp.vue?vue&type=template&id=17b7be27&ts=true"
import script from "./FeatureComp.vue?vue&type=script&lang=ts"
export * from "./FeatureComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__